'use strict';

var constants = require('./constants');

module.exports = function bufferActions(cb) {
  var active = true;
  var queue = [];

  return function (next) {
    return function (action) {
      if (!active) return next(action);
      if (action.type === constants.REHYDRATE) return next(action);
      if (action.type === constants.REHYDRATE_COMPLETE) {
        active = false;
        var result = next(action);
        queue.forEach(function (queuedAction) {
          return next(queuedAction);
        });
        cb(null, queue);
        return result;
      }

      queue.push(action);
    };
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/lib/bufferActions.js
 ** module id = 216
 ** module chunks = 0
 **/